import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import Svg, { Path, Ellipse, Circle, Rect } from "react-native-svg";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import storageActions from "app/utils/storageActions";
import store from "app/redux/store";

import {
  Ionicons,
  MaterialIcons,
  MaterialCommunityIcons,
  FontAwesome,
  SimpleLineIcons,
  FontAwesome5,
  Feather,
  Entypo,
  AntDesign,
  AntIcons,
} from "@expo/vector-icons";

import TimelineNodes from "app/components/TimelineNodes";
import HoverableTooltip from "app/components/HoverableTooltip";
import alertActions from "app/utils/alertActions";

export default class QuickActions extends React.Component {
  static propTypes = {
    value: PropTypes.object.isRequired,
    // onUpdate: PropTypes.func.isRequired,
    bar: PropTypes.bool,
    // onView: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    scale: PropTypes.number,
    showTimeline: PropTypes.bool,
  };

  static defaultProps = {
    scale: 1.0,
  };

  constructor(props) {
    super(props);
    let { preferences } = store.getState();
    let { value } = props;
    this.state = {
      showMore: false,
      preferences,
      openAnim: new Animated.Value(0),
      timelineAnim: new Animated.Value(0),
      loadingIndex: null,
    };
  }

  async componentDidMount() {
    console.log(this.props.value);
    if (!this.props.bar) {
      Animated.spring(this.state.openAnim, {
        toValue: 1,
        // duration: 400,
        friction: 7,
        useNativeDriver: !ENV.WEB,
      }).start(() => {
        Animated.timing(this.state.timelineAnim, {
          toValue: 1,
          duration: 100,
          useNativeDriver: !ENV.WEB,
        }).start();
      });
    }

    // this.subscribe();
    // // focus
    // this.unsubscribeFocus = RootNavigation.addListener("focus", this.subscribe);
    // if (ENV.WEB) window.addEventListener("focus", this.subscribe);
    // this.unsubscribeBlur = RootNavigation.addListener("blur", this.unsubscribe);
    // if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);
  }

  componentWillUnmount() {
    // this.unsubscribeFocus();
    // if (ENV.WEB) window.removeEventListener("focus", this.subscribe);
    // this.unsubscribeBlur();
    // if (ENV.WEB) window.removeEventListener("blur", this.unsubscribe);
    // this.unsubscribe();
  }

  subscribe = async () => {
    // we don't need to subscribe
    // just use the getState from the constructor
    this.unsubscribe = store.subscribe(() => {
      let { preferences } = store.getState();
      this.setState({
        preferences,
      });
    });
  };

  getButtons = () => {
    let { value, bar, onQuickEdit, scale, relationship } = this.props;
    let { preferences, showMore, loadingIndex } = this.state;
    let loading = !!loadingIndex || loadingIndex === 0;
    let { focusIds, hiddenIds } = preferences;
    let wrapperStyle = [
      !bar && styles.iconWrapper,
      {
        justifyContent: "center",
        alignItems: "center",
        width: sizes.itemHeight * 1.5 * scale,
        height: sizes.itemHeight * 1.5 * scale,
      },
    ];
    let iconStyle = [styles.icon, { fontSize: sizes.itemHeight * scale }];
    let isRelative = !!relationship;
    let buttons = [
      // progress
      value.is_note ? (
        <HoverableTooltip text="Convert from note" bottomAligned>
          <TouchableOpacity
            onPress={this.handleToggleNote}
            style={wrapperStyle}
            disabled={loading}
          >
            <FontAwesome
              name={"file-text-o"}
              color={colors.foreground}
              style={iconStyle}
            />
          </TouchableOpacity>
        </HoverableTooltip>
      ) : (
        <HoverableTooltip text="Progress" bottomAligned>
          <TouchableOpacity
            onPress={this.handlePressProgress}
            onLongPress={this.handleLongPressProgress}
            style={wrapperStyle}
            disabled={loading}
          >
            <Feather
              name={"check"}
              color={!!value.completed_at ? colors.active : colors.foreground}
              style={iconStyle}
            />
          </TouchableOpacity>
        </HoverableTooltip>
      ),
      // focus
      isRelative ? (
        <HoverableTooltip text={`Remove as ${relationship.type}`} bottomAligned>
          <TouchableOpacity
            onPress={this.handleRemoveRelationship}
            style={wrapperStyle}
            disabled={loading}
          >
            <FontAwesome
              name={"unlink"}
              color={colors.foreground}
              style={iconStyle}
            />
          </TouchableOpacity>
        </HoverableTooltip>
      ) : null,
      // view
      !bar && (
        <TouchableOpacity
          style={wrapperStyle}
          onPress={() => {
            RootNavigation.push("Value", { id: value.id });
            this.onClose();
          }}
          disabled={loading}
        >
          <Entypo
            name={"chevron-right"}
            color={colors.foreground}
            style={iconStyle}
          />
        </TouchableOpacity>
      ),
      // edit
      !!onQuickEdit && (
        <TouchableOpacity
          onPress={onQuickEdit}
          style={wrapperStyle}
          disabled={loading}
        >
          <AntDesign
            name={"edit"}
            color={colors.foreground}
            style={iconStyle}
          />
        </TouchableOpacity>
      ),
      // pin
      <HoverableTooltip text="Pin to today" bottomAligned>
        <TouchableOpacity
          onPress={this.togglePin}
          style={wrapperStyle}
          disabled={loading}
        >
          <MaterialIcons
            name={"push-pin"}
            // color={isPinned ? this.context.colors.empty : valueColor}
            style={[
              iconStyle,
              //   // { borderColor: valueColor },
              //   {
              //     backgroundColor: isPinned
              //       ? valueColor
              //       : this.context.colors.empty,
              //   },
            ]}
            color={colors.foreground}
          />
        </TouchableOpacity>
      </HoverableTooltip>,
      // <TouchableOpacity onPress={this.handleComplete} style={[styles.labelRow]} disabled={loading}>
      //  <MaterialIcons name={'check-circle'} color={colors.foreground} style={[...iconStyle, styles.iconRing]} />
      //  <Text>Complete</Text>
      //</TouchableOpacity>,
      bar && (
        <TouchableOpacity
          onPress={this.onClose}
          style={wrapperStyle}
          disabled={loading}
        >
          <Feather name={"x"} color={colors.foreground} style={iconStyle} />
        </TouchableOpacity>
      ),
      bar && (
        <TouchableOpacity
          style={wrapperStyle}
          onPress={() => {
            RootNavigation.push("Value", { id: value.id });
            this.onClose();
          }}
          disabled={loading}
        >
          <Entypo
            name={"chevron-right"}
            color={colors.foreground}
            style={styles.icon}
          />
        </TouchableOpacity>
      ),
    ];
    // buttons = buttons.filter((x) => !!x);
    // buttons = buttons.map((b, i) => <View key={i}>{b}</View>);
    return buttons;
  };

  render() {
    let { value, bar, wrapperStyle, showTimeline } = this.props;

    let { preferences, showMore, openAnim, timelineAnim, loadingIndex } =
      this.state;
    let { focusIds, hiddenIds, todoIds } = preferences;

    let rotAnim = openAnim.interpolate({
      inputRange: [0, 1],
      outputRange: [`-135deg`, `0deg`],
    });
    let timelineOpacityAnim = timelineAnim.interpolate({
      inputRange: [0, 1],
      outputRange: [`0`, `1`],
    });

    let buttons = this.getButtons();
    let buttonsLength = buttons.filter((x) => !!x).length;
    // let buttonsLengthOffset = buttons.length - buttonsLength
    let iActual = 0;

    if (bar) {
      return (
        <View style={styles.barWrapper}>
          {buttons.map((button, i) => {
            if (!button) return null;
            if (loadingIndex == i) {
              return (
                <View
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <ActivityIndicator
                    size="large"
                    style={styles.spinner}
                    color={colors.foreground}
                  />
                  <View style={{ opacity: 0.5 }}>{button}</View>
                </View>
              );
            }
            return button;
          })}
        </View>
      );
    }

    return (
      <TouchableOpacity onPress={this.onClose} style={[styles.wrapper]}>
        <Animated.View
          style={[
            StyleSheet.absoluteFillObject,
            { justifyContent: "center", alignItems: "center" },
            { opacity: openAnim },
            { transform: [{ scale: openAnim }, { rotate: rotAnim }] },
          ]}
        >
          {/*<View style={{position: 'absolute'}}>
            <Feather name={'x'} color={colors.foreground} style={styles.icon} />
          </View>*/}

          {buttons.map((button, i) => {
            if (!button) return null;

            {
              /*let iActual = i - buttonsLengthOffset*/
            }
            let rot = iActual * (360 / buttonsLength);
            iActual++;
            return (
              <View
                key={i}
                style={[
                  styles.spoke,
                  {
                    transform: [
                      ENV.WEB ? { translateY: "50%" } : { translateY: 30 },
                      { rotate: `${rot}deg` },
                      ENV.WEB ? { translateY: "-50%" } : { translateY: -30 },
                    ],
                  },
                  // { zIndex: 99 - i },
                  { zIndex: i },
                ]}
              >
                <View style={{ transform: [{ rotate: `-${rot}deg` }] }}>
                  {loadingIndex == i ? (
                    <View
                      style={{ justifyContent: "center", alignItems: "center" }}
                    >
                      <ActivityIndicator
                        size="large"
                        style={styles.spinner}
                        color={colors.foreground}
                      />
                      <View style={{ opacity: 0.5 }}>{button}</View>
                    </View>
                  ) : (
                    button
                  )}
                </View>
              </View>
            );
          })}

          {/*!bar && (
            <TouchableOpacity onPress={() => this.setState({showMore: !showMore})} style={styles.labelRow}>
              <Entypo name={`chevron-${showMore ? 'up' : 'down'}`} color={colors.foreground} style={styles.icon} />
              <Text>{showMore ? 'Less' : 'More'}</Text>
            </TouchableOpacity>
          )*/}

          {showTimeline && (
            <Animated.View
              style={[styles.timelineWrapper, { opacity: timelineOpacityAnim }]}
            >
              <TimelineNodes value={value} />
            </Animated.View>
          )}
        </Animated.View>
      </TouchableOpacity>
    );
  }

  toggleSnooze = async (longPress = false) => {
    this.setState({ loadingIndex: 5 });
    let { value } = this.props;
    // if (valueHelpers.isSnoozed(value)) {
    if (!!value.snooze_until && !longPress) {
      await valueActions.removeSnooze(value.id);
    } else {
      await valueActions.snooze(value);
    }
    this.onClose();
    this.setState({ loadingIndex: null });
  };

  toggleHide = async () => {
    this.setState({ loadingIndex: 6 });
    let { value } = this.props;
    let { preferences } = this.state;
    if (!preferences.hiddenIds.includes(value.id)) {
      await prefActions.hideValue(value.id);
    } else {
      await prefActions.unhideValue(value.id);
    }
    this.onClose();
    this.setState({ loadingIndex: null });
  };

  toggleToDo = async () => {
    this.setState({ loadingIndex: 2 });
    let { value } = this.props;
    let { preferences } = this.state;
    if (preferences.todoIds.includes(value.id)) {
      await prefActions.removeToDo(value.id);
    } else {
      await prefActions.addToDo(value.id);
    }
    this.onClose();
    this.setState({ loadingIndex: null });
  };

  toggleFocus = async () => {
    this.setState({ loadingIndex: 1 });
    let { value } = this.props;
    let { preferences } = this.state;
    if (preferences.focusIds.includes(value.id)) {
      await prefActions.removeFocus(value.id);
    } else {
      await prefActions.addFocus(value.id);
    }
    this.onClose();
    this.setState({ loadingIndex: null });
  };

  toggleTimeline = async () => {
    this.props.toggleTimeline && this.props.toggleTimeline();
    this.onClose();
  };

  handlePressProgress = async () => {
    this.setState({ loadingIndex: 0 });
    let { value } = this.props;
    if (!!value.completed_at) {
      // uncomplete
      value = await valueActions.complete(value);
    } else {
      // create progress
      await this.createProgress();
      this.setState({ loadingIndex: null });
    }
  };

  handleRemoveRelationship = async () => {
    let { value, relationship } = this.props;
    let confirm = await alertActions.confirm({
      title: "Remove relationship?",
      text: "Remove",
      options: ["Archive relationship"],
    });
    if (confirm == 0) return;
    if (confirm == 1) {
      if (relationship.type == "parent")
        await valueActions.removeParent(relationship, value);
      else if (relationship.type == "child")
        await valueActions.removeChild(relationship, value);
    } else if (confirm == 2) {
      if (relationship.type == "parent")
        await valueActions.archiveParent(relationship, value);
      else if (relationship.type == "child")
        await valueActions.archiveChild(relationship, value);
    }
  };

  handleLongPressProgress = async () => {
    this.setState({ loadingIndex: 0 });
    let { value } = this.props;
    console.warn(value.completed_at, value);
    if (!!value.completed_at) {
      // quick revise
      value = await valueActions.quickRevise(value.id);
      if (!!value) this.onClose();
    } else {
      // complete
      value = await valueActions.complete(value);
      if (!!value) this.onClose();
    }
    this.setState({ loadingIndex: null });
  };

  createProgress = async () => {
    let { value, onUpdate } = this.props;
    if (!!value.completed_at) {
      value = await valueActions.complete(value);
      return;
    }
    value = await valueActions.progress(value.id);
    if (!value) return;
    // onUpdate(value)
    this.onClose();
  };

  // handleComplete = async () => {
  //   let { value, onUpdate } = this.props;
  //   value = await valueActions.complete(value);
  //   if (!value) return;
  //   // onUpdate(value)
  //   this.onClose();
  // };

  touchValue = async () => {
    let { value, onUpdate, onDeselect } = this.props;
    let data = {
      value: { updated_at: new Date().toUTCString() },
    };
    value = await apiActions.request(`values/${value.id}`, "PATCH", data);
    console.log(value);
    // !!onUpdate && onUpdate(value)
    // !!onHideQuickActions && onHideQuickActions()
    this.setState({ showQuickActions: false });
    // !!onDeselect && onDeselect()
  };

  onClose = () => {
    if (this.props.bar) {
      this.props.onClose && this.props.onClose();
      return;
    }

    this.state.timelineAnim.setValue(0);

    Animated.timing(this.state.openAnim, {
      toValue: 0,
      duration: 300,
      useNativeDriver: !ENV.WEB,
    }).start(() => {
      this.props.onClose && this.props.onClose();
    });
  };
}

const styles = StyleSheet.create({
  wrapper: {
    position: "absolute",
    // top: -sizes.itemHeight*1.5,
    // right: -sizes.itemHeight*1.5,
    // bottom: -sizes.itemHeight*1.5,
    // left: -sizes.itemHeight*1.5,
    top: sizes.itemHeight * 0.5,
    right: sizes.itemHeight * 0.5,
    bottom: sizes.itemHeight * 0.5,
    left: sizes.itemHeight * 0.5,
    borderRadius: 999,
    zIndex: 99,
    backgroundColor: colorHelpers.hexToRgbaString(colors.fill, 0.5),
  },
  spoke: {
    position: "absolute",
    top: 0,
    bottom: "50%",
    // borderWidth: 1,
  },
  barWrapper: {
    ...StyleSheet.absoluteFillObject,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    flexWrap: "nowrap",
    padding: sizes.large,
    backgroundColor: colorHelpers.hexToRgbaString(colors.fill, 0.9),
    // borderRadius: 5,
  },
  iconWrapper: {
    backgroundColor: colorHelpers.hexToRgbaString(colors.fill, 0.6),
    width: sizes.itemHeight * 1.5,
    height: sizes.itemHeight * 1.5,
    borderRadius: sizes.itemHeight,
    // padding: sizes.small,
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    // borderWidth: 1, borderColor: 'white',
    // marginRight: sizes.base,
    // margin: sizes.base,
    fontSize: sizes.itemHeight,
    // width: sizes.itemHeight,
    // marginHorizontal: sizes.small,
    // padding: sizes.small,
  },
  labelRow: {
    // flex: 1,
    width: "100%",
    // flexGrow: 1,
    // flexShrink: 0,
    // borderWidth: 1, borderColor: 'white',
    flexDirection: "row",
    justifyContent: "center",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  timelineWrapper: {
    position: "absolute",
    top: "150%",
    left: "-300%",
    right: "-300%",
    zIndex: 99,
    borderRadius: 10,
    zIndex: 99,
    borderColor: colors.fill,
    borderWidth: 2,
    backgroundColor: colorHelpers.hexToRgbaString(colors.empty, 0.9),
  },
  spinner: {
    position: "absolute",
    // top: "50%",
    // left: "50%",
    // transform: [{ translateX: `-50%` }, { translateY: `-50%` }],
  },
});
